export enum BuiltInBusinessEvents {
  DEFAULT_HANDOFF_SUPPORT = "ada_handoff_support",
}
